"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _semanticUiReact = require("semantic-ui-react");
function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
      result;
    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
var About = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(About, _React$Component);
  var _super = _createSuper(About);
  function About() {
    (0, _classCallCheck2["default"])(this, About);
    return _super.apply(this, arguments);
  }
  (0, _createClass2["default"])(About, [{
    key: "renderContainer",
    value: function renderContainer(child) {
      var _this$props = this.props,
        withContainer = _this$props.withContainer,
        centerContent = _this$props.centerContent;
      return withContainer ? /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Container, {
        textAlign: centerContent ? 'center' : 'left'
      }, child) : /*#__PURE__*/_react["default"].createElement("div", {
        style: centerContent ? {
          textAlign: 'center'
        } : {}
      }, child);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        header = _this$props2.header,
        content = _this$props2.content,
        headerAs = _this$props2.headerAs;
      return this.renderContainer(/*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
        as: headerAs
      }, header), /*#__PURE__*/_react["default"].createElement("p", null, content)));
    }
  }]);
  return About;
}(_react["default"].Component);
exports["default"] = About;
About.propTypes = {
  content: _propTypes["default"].string.isRequired,
  header: _propTypes["default"].string.isRequired,
  centerContent: _propTypes["default"].bool,
  headerAs: _propTypes["default"].oneOf(['h1', 'h2']),
  withContainer: _propTypes["default"].bool
};
About.defaultProps = {
  centerContent: false,
  headerAs: 'h1',
  withContainer: false
};
About.propOptions = {
  header: ['About Us', 'Our Story']
};
About.dataPropsMap = {
  header: ['business', 'about', 'index', 'title'],
  content: ['business', 'about', 'index', 'content']
};